import Drawer from 'devextreme-react/drawer';
import ScrollView from 'devextreme-react/scroll-view';
import React, { useState, useCallback, useRef } from 'react';
import { useHistory } from 'react-router';
import { Header, Footer } from '../../components';
import './top-nav-layout.scss';


//@@Look here

export default function TopNavLayout({ title, children }) {
  const scrollViewRef = useRef();
  const history = useHistory();

  const toggleMenu = useCallback(({ event }) => {

  }, []);

  const onNavigationChanged = useCallback(({ itemData: { path }, event }) => {
    if (!path) {
      event.preventDefault();
      return;
    }
    history.push(path);
    scrollViewRef.current.instance().scrollTo(0);
  }, [history]);

  return (
    <div className={'top-nav-layout'}>
      <Header
        className={'layout-header'}
        menuToggleEnabled={false}
        toggleMenu={toggleMenu}
        title={title}
        selectedItemChanged={onNavigationChanged}
      />

      <div className={'container'}>
          <ScrollView ref={scrollViewRef} className={'layout-body with-footer'}>
            <div className={'content'}>
              {React.Children.map(children, item => {
                return item.type !== Footer && item;
              })}
            </div>
            <div className={'content-block'}>
              {React.Children.map(children, item => {
                return item.type === Footer && item;
              })}
            </div>
          </ScrollView>
        </div>
    </div>
  );
}

